import React from 'react';
import Isvg from 'react-inlinesvg';
import { Tooltip } from 'reactstrap';

import QuestionIcon from 'app/images/icons/question.svg';

interface IHelpTooltipProps {
  id: string;
  children?: any;
  placement?: string;
}

interface IHelpTooltipState {
  tooltipOpen: any;
}

export default class HelpTooltip extends React.Component<
  IHelpTooltipProps,
  IHelpTooltipState
> {
  state = {
    tooltipOpen: false,
  };

  toggleTooltip = () => {
    this.setState((previousState) => ({
      tooltipOpen: !previousState.tooltipOpen,
    }));
  };

  render() {
    return (
      <div className="d-inline-block">
        <div id={this.props.id}>
          <Isvg className="help-icon" src={QuestionIcon} />
        </div>
        <Tooltip
          placement={this.props.placement || 'auto'}
          isOpen={this.state.tooltipOpen}
          target={this.props.id}
          toggle={this.toggleTooltip}
          className="grey"
        >
          {this.props.children}
        </Tooltip>
      </div>
    );
  }
}
